<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" persistent width="300">
      <v-card color="#E2C378" dark>
        <v-card-title style="color: #4c1a65"> กรุณารอสักครู่... </v-card-title>
        <v-card-text>
          <v-progress-linear indeterminate color="#4c1a65" class="mb-0" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "Loading",
  data() {
    return {
      dialog: false,
    }
  },

  watch: {
    dialog(val) {
      if (!val) return

      setTimeout(() => (this.dialog = false), 4000)
    },
  },

  methods: {
    show() {
      this.dialog = true
    },
  },
}
</script>
